import api from "./axios.service";
import { getQueryStringFromObject } from "./common.service";
const axios = api;

async function getMovies(query = {}) {
    try {
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = '?' + queryString;
        } else {
            queryString = '';
        }
        let response = await axios.get('/movies' + queryString);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


async function insertMovie(movieData) {
    try {
        let response = await axios.post('/movies', movieData);
        return response.data;
    } catch (error) {
        return { error: error.message || 'An error occurred' };
    }
}


export {
    getMovies,
    insertMovie
}